import { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './VehicleSlideshow.css';

const slides = [
  {
    img: '/vehicle-1.png',
    label: 'Cold Chain — Mountain Operations',
    sub: 'GDP compliant · 2°C to −25°C · Real-time temp monitoring',
    tag: 'Phase 1 Fleet',
  },
  {
    img: '/vehicle-2.png',
    label: 'Cold Chain — Desert Highway Operations',
    sub: 'Long-haul capable · 250 km range · AI-assisted routing',
    tag: 'Phase 1 Fleet',
  },
  {
    img: '/bg-vehicle.png',
    label: 'Cold Chain — Urban Night Operations',
    sub: '24/7 fleet ready · AI CCTV · Axion OS connected',
    tag: 'Phase 1 Fleet',
  },
];

export default function VehicleSlideshow() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  const go = useCallback((dir) => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => setAnimating(false), 600);
    setCurrent(c => (c + dir + slides.length) % slides.length);
  }, [animating]);

  useEffect(() => {
    const t = setInterval(() => go(1), 5000);
    return () => clearInterval(t);
  }, [go]);

  return (
    <section className="vslide-section">
      <div className="vslide-header">
        <span className="vslide-eyebrow">Our Fleet in Action</span>
        <h2>Built for Every Environment</h2>
        <p>EV cold-chain trucks engineered to perform across urban, mountain, and highway conditions.</p>
      </div>

      <div className="vslide-stage">
        {slides.map((s, i) => (
          <div
            key={i}
            className={`vslide ${i === current ? 'vslide--active' : ''} ${animating && i === current ? 'vslide--fade' : ''}`}
          >
            <img src={s.img} alt={s.label} className="vslide-img" />
            <div className="vslide-overlay" />
            <div className="vslide-caption">
              <span className="vslide-tag">{s.tag}</span>
              <h3>{s.label}</h3>
              <p>{s.sub}</p>
            </div>
          </div>
        ))}

        <button className="vslide-btn vslide-btn--prev" onClick={() => go(-1)} aria-label="Previous">
          <ChevronLeft size={22} />
        </button>
        <button className="vslide-btn vslide-btn--next" onClick={() => go(1)} aria-label="Next">
          <ChevronRight size={22} />
        </button>

        <div className="vslide-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`vslide-dot ${i === current ? 'vslide-dot--active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
